import { BUTTON_VARIANT, type ButtonProps } from '@fukku/button/Button.types'
import { cx } from 'classix'
import { ButtonBase } from '../Base/ButtonBase'
import { ButtonContentWrapper } from '../ButtonContentWrapper/ButtonContentWrapper'
import styles from './ButtonPrimary.module.css'

export function ButtonPrimary(props: Readonly<ButtonProps>): React.ReactNode {
	const {
		isLoading = false,
		variant = BUTTON_VARIANT.DEFAULT,
		className,
		disabled,
		children,
		fullWidth,
		accessibilityText,
		...rest
	} = props

	const disabledButton = disabled || isLoading

	return (
		<ButtonBase
			{...rest}
			className={cx(
				styles[variant],
				disabled && !isLoading && styles.disabled,
				className
			)}
			fullWidth={fullWidth}
			disabled={disabledButton}
		>
			<ButtonContentWrapper
				isLoading={isLoading}
				variant={BUTTON_VARIANT.DEFAULT}
				accessibilityText={accessibilityText}
			>
				{children}
			</ButtonContentWrapper>
		</ButtonBase>
	)
}
